import request from '../../utils/request'
//获取新闻列表
export function getNewsList(query) {
  return request({
    url: '/news/list',
    method: 'get',
    params: query
  })
}
//获取新闻详情
export function getNewsDetails(id) {
  console.log('id', id)
  return request({
    url: `/news/${id}`,
    method: 'get',
  })
}

//获取Tag列表
export function getTagList(query) {
  return request({
    url: '/news/tagList',
    method: 'get',
    params: query
  })
}
//获取友链
export function getLinkList(query) {
  return request({
    url: '/friendLink/list',
    method: 'get',
    params: query
  })
}
//获取评论列表
export function getCommentList(query) {
  return request({
    url: '/comment/list',
    method: 'get',
    params: query
  })
}
//添加评论
export function addComment(data) {
  return request({
    url: '/comment/push',
    method: 'post',
    data: data
  })
}
//删除评论
export function deleteComment(data) {
  return request({
    url: `/comment/remove`,
    method: 'post',
    data: data
  })
}
//专家列表
export function getExpertList(query) {
  return request({
    url: '/expert/list',
    method: 'get',
    params: query
  })
}
//专家详情
export function getExpertDetails(query) {
  return request({
    url: `/expert/getById`,
    method: 'get',
    params: query
  })
} 


// WEBPACK FOOTER //
// ./src/assets/api/news.js